import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ParamContext } from '../../../shared/service/param.context';
import { SERVER_API_URL } from '../../../app.constants';
import { ExperimentalDesignParameters } from './experimental-design.parameters.model';
import { Observable } from 'rxjs';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../../shared/loading-indicator';

@Injectable({
    providedIn: 'root'
})
export class ExperimentDesignService {

    constructor(private http: HttpClient,
                private paramContext: ParamContext) {
    }

    generateDesign(studyId: number, experimentDesignInput: ExperimentalDesignParameters) {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/experimental-designs/generation`;
        return this.http.post(url, experimentDesignInput, { context: new HttpContext().set(EnableSavingIndicator, true) });

    }

    deleteDesign(studyId: number) {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/experimental-designs`;
        return this.http.delete(url, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    importDesign(studyId: number, designImportRequest) {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/experimental-designs/import`;
        return this.http.post(url, designImportRequest, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    exportDesignTemplate(studyId: number) {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/experimental-designs/export/template`;
        return this.http.get(url,
            {
                responseType: 'blob',
                observe: 'response',
                context: new HttpContext().set(EnableLoadingIndicator, true)
            }
        );
    }

    getBVDesignLicense() {
        return this.http.get('/bmsapi/breeding-view-licenses', { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    getLoginPageDetails() {
        return this.http.get('/bmsapi/auth/login', { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    getDesignTypes() {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/experimental-design-types?programUUID=${this.paramContext.programUUID}`;
        return this.http.get(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    getInsertionManners(): Observable<{id: string, name: string, description: string}[]> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/check-insertion-manners?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<{id: string, name: string, description: string}[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

}

export interface MapItem {
    id: string;
    name: string;
    variable?: MapItemVariable
    property?: string;
    scale?: string;
    method?: string;
    required?: boolean;
}

export interface MapItemVariable {
    id: string,
    name: string,
    property: string,
    scale: string,
    method: string,
    variableTypeId: number,
    dataTypeId: number,
    scaleId: number,
    pairedVariableId?: number,
    isTreatmentLabelVariable?: boolean
}

export interface DesignImportRequest {
    mappedHeaders: MapItem[];
    rowData: any[];
    designSource: string;
    maintainHeaderNames: boolean;
}
